
import React from 'react';
import { Button } from '@/components/ui/button';
import { ToggleRight, ToggleLeft } from 'lucide-react';
import DeleteUserDialog from './DeleteUserDialog';

type UserActionsProps = {
  userId: string;
  email: string;
  role: string;
  isActive: boolean;
  isDeleting: boolean;
  onSetAdminRole: (email: string) => Promise<void>;
  onDeleteUser: (userId: string, email: string) => Promise<void>;
  onToggleActive: (userId: string, isActive: boolean) => Promise<void>;
};

const UserActions: React.FC<UserActionsProps> = ({ 
  userId, 
  email, 
  role, 
  isActive,
  isDeleting,
  onSetAdminRole, 
  onDeleteUser,
  onToggleActive
}) => {
  const handleDeleteUser = async () => {
    await onDeleteUser(userId, email);
  };

  const handleToggleActive = async () => {
    await onToggleActive(userId, !isActive);
  };

  return (
    <div className="space-x-2">
      {role !== 'admin' && (
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => onSetAdminRole(email)}
        >
          Définir comme admin
        </Button>
      )}
      
      <Button 
        variant={isActive ? "outline" : "destructive"} 
        size="sm" 
        onClick={handleToggleActive}
      >
        {isActive ? (
          <>
            <ToggleRight className="h-4 w-4 mr-1" />
            Désactiver
          </>
        ) : (
          <>
            <ToggleLeft className="h-4 w-4 mr-1" />
            Activer
          </>
        )}
      </Button>
      
      <DeleteUserDialog 
        email={email}
        isDeleting={isDeleting}
        onDelete={handleDeleteUser}
      />
    </div>
  );
};

export default UserActions;
